import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getBasePath() {
  const path = window.location.pathname;
  const segments = path.split('/').filter(Boolean);
  const reactRoutes = ['kurumsal', 'haberler', 'proje', 'galeri', 'iletisim', 'admin', 'sayfa'];
  const routeIndex = segments.findIndex(seg => reactRoutes.includes(seg));
  
  if (routeIndex !== -1) {
    const subdirSegments = segments.slice(0, routeIndex);
    return subdirSegments.length > 0 ? `/${subdirSegments.join('/')}` : '';
  }
  
  const cleanSegments = segments.filter(seg => seg !== 'index.html');
  return cleanSegments.length > 0 ? `/${cleanSegments.join('/')}` : '';
}

export function getBackendUrl() {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  return window.location.origin + getBasePath();
}

export function getImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  
  let targetUrl = url;
  const ext = url.split('.').pop().toLowerCase();
  const isLocalImage = url.startsWith('/api/uploads/') || 
                       url.startsWith('api/uploads/') || 
                       url.startsWith('/images/') || 
                       url.startsWith('images/');
                       
  if (['jpg', 'jpeg', 'png', 'webp', 'avif'].includes(ext) && isLocalImage) {
    const targetExt = localStorage.getItem('target_image_format') || 'webp';
    targetUrl = url.substring(0, url.lastIndexOf('.')) + '.' + targetExt;
  }

  const base = getBasePath();
  
  if (targetUrl.startsWith('/images/')) {
    return `${base}${targetUrl}`;
  }
  const backendUrl = getBackendUrl();
  return `${backendUrl}${targetUrl}`;
}

export async function translateAndSlugify(text) {
  if (!text) return '';
  try {
    const response = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=tr&tl=en&dt=t&q=${encodeURIComponent(text)}`
    );
    const data = await response.json();
    let translated = '';
    if (data && data[0]) {
      translated = data[0].map(item => item[0]).join('');
    } else {
      translated = text;
    }

    return translated
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  } catch (e) {
    console.error("Translation slugify failed, fallback to local sanitization", e);
    const find = ['ç', 'ğ', 'ı', 'ö', 'ş', 'ü', 'Ç', 'Ğ', 'İ', 'Ö', 'Ş', 'Ü'];
    const replace = ['c', 'g', 'i', 'o', 's', 'u', 'c', 'g', 'i', 'o', 's', 'u'];
    let localSlug = text;
    for (let i = 0; i < find.length; i++) {
      localSlug = localSlug.replace(new RegExp(find[i], 'g'), replace[i]);
    }
    return localSlug
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  }
}
